import React, { useContext } from 'react';
import { Typography, MenuItem, SelectChangeEvent, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UserRoles } from 'constants/userRoles';
import { StyledRoleSelect } from './RoleSelector.styles';
import { useAuthContext } from 'hooks/useAuthContext';

interface RoleSelectorProps {
  value: UserRoles;
  onChange: (event: SelectChangeEvent<UserRoles>) => void;
  disabled?: boolean;
}

const RoleSelector: React.FC<RoleSelectorProps> = ({ value, onChange, disabled }) => {
  const { userState } = useAuthContext();
  const { t } = useTranslation();
  const isAdmin = value === UserRoles.ADMIN;

  const showPatronLight = [UserRoles.Patron, UserRoles.PatronLight].includes(value) || isAdmin;
  const showPatron = [UserRoles.Patron].includes(value) || isAdmin;

  const handleChange = (event: SelectChangeEvent<unknown>, child: React.ReactNode) => {
    onChange(event as SelectChangeEvent<UserRoles>);
  };

  if (!userState?.user?.userId) {
    return <CircularProgress/>
  }

  const currentUserRole = userState.user.selectedWorkspace.userRole as UserRoles;
  const shouldOverrideSettings = 
  (currentUserRole === UserRoles.ADMIN || currentUserRole === UserRoles.Patron);

const options = shouldOverrideSettings ? [
  UserRoles.Patron,
  UserRoles.PatronLight,
  UserRoles.Participant,
] : [
  UserRoles.Participant,
  ...(showPatronLight ? [UserRoles.PatronLight] : []),
  ...(showPatron ? [UserRoles.Patron] : []),
  ...(isAdmin ? [UserRoles.ADMIN] : []),
];

  return (
    <>
      <Typography fontWeight="500" variant="subtitle1">
        {t('general.role')}:
      </Typography>
      <StyledRoleSelect
        value={value}
        onChange={handleChange}
        variant="outlined"
        disabled={disabled || isAdmin}
      >
       {options.map(role => (
      <MenuItem key={role} value={role}>{t(`roles.${role}`)}</MenuItem>
    ))}
      </StyledRoleSelect>
    </>
  );
};

export default RoleSelector;
